export const THOUGHT_JOURNAL_GET_JOURNALS_BEGIN = 'THOUGHT_JOURNAL_GET_JOURNALS_BEGIN';
export const THOUGHT_JOURNAL_GET_JOURNALS_SUCCESS = 'THOUGHT_JOURNAL_GET_JOURNALS_SUCCESS';
export const THOUGHT_JOURNAL_GET_JOURNALS_FAILURE = 'THOUGHT_JOURNAL_GET_JOURNALS_FAILURE';
export const THOUGHT_JOURNAL_GET_JOURNALS_DISMISS_ERROR =
  'THOUGHT_JOURNAL_GET_JOURNALS_DISMISS_ERROR';
export const THOUGHT_JOURNAL_SET_READ_STATUS_BEGIN = 'THOUGHT_JOURNAL_SET_READ_STATUS_BEGIN';
export const THOUGHT_JOURNAL_SET_READ_STATUS_SUCCESS = 'THOUGHT_JOURNAL_SET_READ_STATUS_SUCCESS';
export const THOUGHT_JOURNAL_SET_READ_STATUS_FAILURE = 'THOUGHT_JOURNAL_SET_READ_STATUS_FAILURE';
export const THOUGHT_JOURNAL_SET_READ_STATUS_DISMISS_ERROR =
  'THOUGHT_JOURNAL_SET_READ_STATUS_DISMISS_ERROR';
export const THOUGHT_JOURNAL_SET_FILTERED = 'THOUGHT_JOURNAL_SET_FILTERED';



// WEBPACK FOOTER //
// ./src/features/thought-journal/redux/constants.js